/** Wirft, wenn die Bedingung nicht gilt. Verschmaelert gleichzeitig den Typ. */
export function invariant(condition: unknown, message: string): asserts condition {
  if (!condition) throw new Error(message);
}
